import {CartClient} from './cx-box-core.js?v=cx-box-001c';
let busy=false;
document.addEventListener('click',async event=>{
  const button=event.target.closest('[data-remove-box]');if(!button||busy)return;
  const group=button.closest('[data-box-cart]');const status=group.querySelector('[data-box-cart-status]');
  busy=true;button.disabled=true;status.hidden=false;status.textContent='Retirando solo los componentes de esta caja…';
  try{
    const work=()=>new CartClient(group.dataset.root).removeGroup(button.dataset.removeBox);
    if(navigator.locks)await navigator.locks.request('crysalidas-box-cart',work);else await work();
    location.reload();
  }catch{status.textContent='No se ha terminado de retirar la caja. Revisa la cesta y vuelve a intentarlo.';button.disabled=false;busy=false;}
});
// A failed/uncertain grouped operation must be explicitly recovered before payment.
// This is only a theme UX guard, not a server-side checkout validation function.
function pending(){try{return JSON.parse(sessionStorage.getItem('cx-box-pending-v1')||'null');}catch{return null;}}
document.addEventListener('click',event=>{
  if(!pending()||!event.target.closest('[name="checkout"],a[href*="/checkout"],shopify-accelerated-checkout-cart'))return;
  event.preventDefault();event.stopImmediatePropagation();
  const node=document.querySelector('[data-box-cart]');const path=node?.dataset.builder||'/collections/crea-tu-caja?view=crea-tu-caja';location.assign(path);
},true);
document.addEventListener('submit',event=>{
  if(!pending()||event.submitter?.name!=='checkout')return;
  event.preventDefault();event.stopImmediatePropagation();
  location.assign(document.querySelector('[data-box-cart]')?.dataset.builder||'/collections/crea-tu-caja?view=crea-tu-caja');
},true);
function showPending(){
  const value=pending();if(!value)return;
  for(const group of document.querySelectorAll('[data-box-cart]')){
    const status=group.querySelector('[data-box-cart-status]');status.hidden=false;status.textContent='Hay una caja pendiente de recuperar. Vuelve al constructor antes de pagar. ';
    const a=document.createElement('a');a.href=group.dataset.builder;a.textContent='Recuperar caja';status.append(a);
  }
}
showPending();document.addEventListener('cart:update',showPending);
